export default __webpack_public_path__ + "static/media/foodle-int01.207f0b6b.gif";